import { decode } from 'he';
import { getTiptapTextRange } from '../helpers/getTiptapTextRange';

const blockHtmlToTiptapText = (html) => decode(html
  // remove starting tags
  .replace(/^(<[^>]+>)+/g, '')
  // remove closing tags
  .replace(/(<\/[^>]+>)+$/g, '')

  // TODO: fix me
  .replaceAll('</li></ul></li></ul></li></ul></li><li>', '\n\n\n\n\n\n\n\n\n\n')
  .replaceAll('</li></ul></li></ul></li><li>', '\n\n\n\n\n\n\n\n')
  .replaceAll('</li></ul></li><li>', '\n\n\n\n\n\n')
  .replaceAll('</li></ul></li>', '\n\n\n\n\n\n')
  .replaceAll('<ul><li>', '\n\n\n\n')

  .replaceAll('</li></ol></li></ol></li></ol></li><li>', '\n\n\n\n\n\n\n\n\n\n')
  .replaceAll('</li></ol></li></ol></li><li>', '\n\n\n\n\n\n\n\n')
  .replaceAll('</li></ol></li><li>', '\n\n\n\n\n\n')
  .replaceAll('</li></ol></li>', '\n\n\n\n\n\n')
  .replaceAll('<ul><li>', '\n\n\n\n')

  .replaceAll('</li><li>', '\n\n\n\n')
  .replace(/<[^>]*>/g, ''));

/**
 *
 * @param nudge
 */
export function addNudge(nudge) {
  return ({ editor, chain }) => {
    const { block = {}, messages = [] } = nudge;
    const { severity_class: severity = null } = messages[0] || {};
    const { id, html } = block;
    const count = messages.length;

    this.storage.nudges[id] = nudge;

    if (this.storage.nudges[id]?.hide) {
      return chain();
    }

    const blockText = blockHtmlToTiptapText(html);

    const { from, to } = getTiptapTextRange({
      html: editor.getHTML(), lookupText: blockText, occurrence: 0,
    });

    if (from === to) {
      return chain();
    }

    const tagToNodeType = [
      ['<p', 'paragraph'],
      ['<h', 'heading'],
      ['<ul', 'bulletList'],
      ['<ol', 'orderedList'],
    ];
    const [, nodeType] = tagToNodeType.find(([tag]) => html.startsWith(tag)) || [];

    return chain()
      .setNodeSelection(from)
      .updateAttributes('heading', { nudgeId: id, severity, count }) // workaround for no-paragraph editor
      .updateAttributes(nodeType, { nudgeId: id, severity, count });
  };
}

/**
 *
 * @param nudges
 */
export function setNudges(nudges = []) {
  return ({ chain, editor }) => {
    const { anchor, head } = editor.view.state.selection;

    chain().setMeta('addToHistory', false).setMeta('contentNotUpdated', true);
    chain().removeAllNudges();

    nudges.forEach((nudge) => {
      chain().addNudge(nudge);
    });

    chain().setTextSelection({ from: anchor, to: head });
  };
}

/**
 *
 */
export function removeAllNudges() {
  return ({ chain }) => chain()
    .setMeta('addToHistory', false)
    .setMeta('contentNotUpdated', true)
    .setTextSelection({ from: 1, to: 10e6 })
    .resetAttributes('paragraph', ['nudgeId', 'severity', 'count'])
    .resetAttributes('heading', ['nudgeId', 'severity', 'count'])
    .resetAttributes('bulletList', ['nudgeId', 'severity', 'count'])
    .resetAttributes('orderedList', ['nudgeId', 'severity', 'count']);
}

/**
 *
 * @param root0
 * @param root0.id
 * @param root0.suggestion
 */
export function insertNudgeSuggestion({ id, suggestion = '' }) {
  return ({ editor, chain }) => {
    const nudge = this.storage.nudges[id];
    const { block = {} } = nudge;
    const { html } = block;
    const isParagraph = html.toLowerCase().startsWith('<p');

    if (!nudge) {
      return chain();
    }

    const blockText = blockHtmlToTiptapText(html);

    const { to } = getTiptapTextRange({
      html: editor.getHTML(), lookupText: blockText, occurrence: 0,
    });

    nudge.hide = true;

    return chain()
      .setTextSelection(to)
      .command(({ commands, can }) => {
        if (isParagraph) {
          return commands.splitBlock({ keepMarks: false });
        }
        if (can().splitListItem('listItem')) {
          return commands.splitListItem('listItem');
        }
        return true;
      })
      .insertContent(suggestion)
      .focus();
  };
}
